import MarkerBar from '@/assets/img/map/marker-bar.png'
import MarkerBarLgbt from '@/assets/img/map/marker-bar-lgbt.png'
import MarkerBarCert from '@/assets/img/map/marker-bar-cert.png'
import MarkerBarLgbtCert from '@/assets/img/map/marker-bar-lgbt-cert.png'

import MarkerRestaurant from '@/assets/img/map/marker-restaurant.png'
import MarkerRestaurantLgbt from '@/assets/img/map/marker-restaurant-lgbt.png'
import MarkerRestaurantCert from '@/assets/img/map/marker-restaurant-cert.png'
import MarkerRestaurantLgbtCert from '@/assets/img/map/marker-restaurant-lgbt-cert.png'

import MarkerCoffee from '@/assets/img/map/marker-coffee.png'
import MarkerCoffeeLgbt from '@/assets/img/map/marker-coffee-lgbt.png'
import MarkerCoffeeCert from '@/assets/img/map/marker-coffee-cert.png'
import MarkerCoffeeLgbtCert from '@/assets/img/map/marker-coffee-lgbt-cert.png'

import MarkerNightlife from '@/assets/img/map/marker-nightclub.png'
import MarkerNightlifeLgbt from '@/assets/img/map/marker-nightclub-lgbt.png'
import MarkerNightlifeCert from '@/assets/img/map/marker-nightclub-cert.png'
import MarkerNightlifeLgbtCert from '@/assets/img/map/marker-nightclub-lgbt-cert.png'

import MarkerActivity from '@/assets/img/map/marker-activity.png'
import MarkerActivityLgbt from '@/assets/img/map/marker-activity-lgbt.png'
import MarkerActivityCert from '@/assets/img/map/marker-activity-cert.png'
import MarkerActivityLgbtCert from '@/assets/img/map/marker-activity-lgbt-cert.png'

import MarkerGame from '@/assets/img/map/marker-game.png'
import MarkerGameLgbt from '@/assets/img/map/marker-game-lgbt.png'
import MarkerGameCert from '@/assets/img/map/marker-game-cert.png'
import MarkerGameLgbtCert from '@/assets/img/map/marker-game-lgbt-cert.png'

import MarkerOutdoor from '@/assets/img/map/marker-outdoor.png'
import MarkerOutdoorLgbt from '@/assets/img/map/marker-outdoor-lgbt.png'
import MarkerOutdoorCert from '@/assets/img/map/marker-outdoor-cert.png'
import MarkerOutdoorLgbtCert from '@/assets/img/map/marker-outdoor-lgbt-cert.png'

import MarkerMuseum from '@/assets/img/map/marker-museum.png'
import MarkerMuseumLgbt from '@/assets/img/map/marker-museum-lgbt.png'
import MarkerMuseumCert from '@/assets/img/map/marker-museum-cert.png'
import MarkerMuseumLgbtCert from '@/assets/img/map/marker-museum-lgbt-cert.png'

import MarkerShop from '@/assets/img/map/marker-shop.png'
import MarkerShopLgbt from '@/assets/img/map/marker-shop-lgbt.png'
import MarkerShopCert from '@/assets/img/map/marker-shop-cert.png'
import MarkerShopLgbtCert from '@/assets/img/map/marker-shop-lgbt-cert.png'

import MarkerSnack from '@/assets/img/map/marker-snack.png'
import MarkerSnackLgbt from '@/assets/img/map/marker-snack-lgbt.png'
import MarkerSnackCert from '@/assets/img/map/marker-snack-cert.png'
import MarkerSnackLgbtCert from '@/assets/img/map/marker-snack-lgbt-cert.png'

import MarkerBarber from '@/assets/img/map/marker-barber.png'
import MarkerBarberLgbt from '@/assets/img/map/marker-barber-lgbt.png'
import MarkerBarberCert from '@/assets/img/map/marker-barber-cert.png'
import MarkerBarberLgbtCert from '@/assets/img/map/marker-barber-lgbt-cert.png'

import MarkerWellness from '@/assets/img/map/marker-wellness.png'
import MarkerWellnessLgbt from '@/assets/img/map/marker-wellness-lgbt.png'
import MarkerWellnessCert from '@/assets/img/map/marker-wellness-cert.png'
import MarkerWellnessLgbtCert from '@/assets/img/map/marker-wellness-lgbt-cert.png'

import MarkerHotel from '@/assets/img/map/marker-hotel.png'
import MarkerHotelLgbt from '@/assets/img/map/marker-hotel-lgbt.png'
import MarkerHotelCert from '@/assets/img/map/marker-hotel-cert.png'
import MarkerHotelLgbtCert from '@/assets/img/map/marker-hotel-lgbt-cert.png'

import MarkerNonprofit from '@/assets/img/map/marker-nonprofit.png'
import MarkerNonprofitLgbt from '@/assets/img/map/marker-nonprofit-lgbt.png'
import MarkerNonprofitCert from '@/assets/img/map/marker-nonprofit-cert.png'
import MarkerNonprofitLgbtCert from '@/assets/img/map/marker-nonprofit-lgbt-cert.png'

import MarkerHealth from '@/assets/img/map/marker-health.png'
import MarkerHealthLgbt from '@/assets/img/map/marker-health-lgbt.png'
import MarkerHealthCert from '@/assets/img/map/marker-health-cert.png'
import MarkerHealthLgbtCert from '@/assets/img/map/marker-health-lgbt-cert.png'

import MarkerInterest from '@/assets/img/map/marker-interest.png'
import MarkerInterestLgbt from '@/assets/img/map/marker-interest-lgbt.png'
import MarkerInterestCert from '@/assets/img/map/marker-interest-cert.png'
import MarkerInterestLgbtCert from '@/assets/img/map/marker-interest-lgbt-cert.png'

import MarkerBuilding from '@/assets/img/map/marker-building.png'
import MarkerBuildingLgbt from '@/assets/img/map/marker-building-lgbt.png'
import MarkerBuildingCert from '@/assets/img/map/marker-building-cert.png'
import MarkerBuildingLgbtCert from '@/assets/img/map/marker-building-lgbt-cert.png'

import PointRestauration from '@/assets/img/map/point-restauration.png'
import PointRestaurationLgbt from '@/assets/img/map/point-restauration-lgbt.png'

import PointShopping from '@/assets/img/map/point-shopping.png'
import PointShoppingLgbt from '@/assets/img/map/point-shopping-lgbt.png'

import PointActivity from '@/assets/img/map/point-activity.png'
import PointActivityLgbt from '@/assets/img/map/point-activity-lgbt.png'

import PointNightlife from '@/assets/img/map/point-nightlife.png'
import PointNightlifeLgbt from '@/assets/img/map/point-nightlife-lgbt.png'

import PointNonprofit from '@/assets/img/map/point-nonprofit.png'
import PointNonprofitLgbt from '@/assets/img/map/point-nonprofit-lgbt.png'

import PointCity from '@/assets/img/map/point-city.png'
import PointCityLgbt from '@/assets/img/map/point-city-lgbt.png'

export const MAP_TYPES = {
  bar: {
    types: [ 'bar', 'bar', 'pub', 'juice_bar', 'snack_bar' ],
    icons: {
      default: MarkerBar,
      lgbt: MarkerBarLgbt,
      cert: MarkerBarCert,
      lgbtCert: MarkerBarLgbtCert
    }
  },
  restaurant: {
    types: [ 'restaurant', 'mexican_restaurant', 'asian_restaurant', 'indian_restaurant', 'italian_restaurant', 'chinese_restaurant', 'pizza_restaurant', 'brunch_restaurant', 'breakfast_restaurant', 'taco_shop', 'sandwich_shop', 'noodle_restaurant', 'american_restaurant', 'deli', 'diner_restaurant', 'barbeque_restaurant' ],
    icons: {
      default: MarkerRestaurant,
      lgbt: MarkerRestaurantLgbt,
      cert: MarkerRestaurantCert,
      lgbtCert: MarkerRestaurantLgbtCert
    }
  },
  coffee: {
    types: [ 'cafe', 'coffee_shop' ],
    icons: {
      default: MarkerCoffee,
      lgbt: MarkerCoffeeLgbt,
      cert: MarkerCoffeeCert,
      lgbtCert: MarkerCoffeeLgbtCert
    }
  },
  snack: {
    types: [ 'snack_bar', 'bakery', 'dessert_shop' ],
    icons: {
      default: MarkerSnack,
      lgbt: MarkerSnackLgbt,
      cert: MarkerSnackCert,
      lgbtCert: MarkerSnackLgbtCert
    }
  },
  nightlife: {
    types: [ 'night_club', 'nightlife', 'nightclub' ],
    icons: {
      default: MarkerNightlife,
      lgbt: MarkerNightlifeLgbt,
      cert: MarkerNightlifeCert,
      lgbtCert: MarkerNightlifeLgbtCert
    }
  },
  activity: {
    types: [ 'amusement_park', 'aquarium', 'bowling_alley', 'movie_theater', 'amusement_park', 'aquarium', 'art_gallery', 'bowling_alley', 'movie_theater', 'theme_park', 'cinema', 'entertainment' ],
    icons: {
      default: MarkerActivity,
      lgbt: MarkerActivityLgbt,
      cert: MarkerActivityCert,
      lgbtCert: MarkerActivityLgbtCert
    }
  },
  game: {
    types: [ 'bowling_alley', 'bowling_alley', 'video_game_store' ],
    icons: {
      default: MarkerGame,
      lgbt: MarkerGameLgbt,
      cert: MarkerGameCert,
      lgbtCert: MarkerGameLgbtCert
    }
  },
  outdoor: {
    types: [ 'park', 'zoo', 'natural_feature', 'park', 'park', 'zoo', 'natural_feature', 'outdoors', 'forest', 'lake', 'river', 'canal', 'island', 'nature_reserve', 'garden', 'playground', 'field' ],
    icons: {
      default: MarkerOutdoor,
      lgbt: MarkerOutdoorLgbt,
      cert: MarkerOutdoorCert,
      lgbtCert: MarkerOutdoorLgbtCert
    }
  },
  museum: {
    types: [ 'museum', 'art_gallery', 'aquarium', 'museum', 'art_gallery', 'aquarium', 'studio', 'outdoor_sculpture' ],
    icons: {
      default: MarkerMuseum,
      lgbt: MarkerMuseumLgbt,
      cert: MarkerMuseumCert,
      lgbtCert: MarkerMuseumLgbtCert
    }
  },
  shop: {
    types: [ 'store', 'shopping_mall', 'book_store', 'library', 'store', 'shopping_mall', 'book_store', 'library', 'clothing_store', 'supermarket', 'wholesale_store', 'beauty_store', 'electronics_shop', 'repair_shop', 'photo_store', 'furniture_store', 'convenience_store', 'gift_shop', 'jewelry_store', 'hardware_store', 'phone_store', 'toy_store', 'shoe_store', 'fashion_accessory_shop', 'arts_and_craft_store', 'copyshop', 'paper_goods_store', 'liquor_store', 'ice_cream', 'medical_supply_store', 'massage_shop', 'department_store', 'news_kiosk', 'garden_store', 'sandwich_shop', 'pawnshop', 'lighting_store', 'thrift_shop', 'mattress_store', 'baby_goods_shop', 'fishing_store' ],
    icons: {
      default: MarkerShop,
      lgbt: MarkerShopLgbt,
      cert: MarkerShopCert,
      lgbtCert: MarkerShopLgbtCert
    }
  },
  barber: {
    types: [ 'barber', 'hairdresser', 'salon', 'nail_salon' ],
    icons: {
      default: MarkerBarber,
      lgbt: MarkerBarberLgbt,
      cert: MarkerBarberCert,
      lgbtCert: MarkerBarberLgbtCert
    }
  },
  wellness: {
    types: [ 'spa', 'massage_shop', 'wellness', 'rehabilitation_center', 'alternative_healthcare', 'chiropractor' ],
    icons: {
      default: MarkerWellness,
      lgbt: MarkerWellnessLgbt,
      cert: MarkerWellnessCert,
      lgbtCert: MarkerWellnessLgbtCert
    }
  },
  hotel: {
    types: [ 'hotel', 'lodging', 'bed_and_breakfast', 'hostel', 'motel' ],
    icons: {
      default: MarkerHotel,
      lgbt: MarkerHotelLgbt,
      cert: MarkerHotelCert,
      lgbtCert: MarkerHotelLgbtCert
    }
  },
  nonprofit: {
    types: [ 'non-profit organisation', 'non-profit organization', 'nonprofit', 'charity', 'nongovernmental_organization', 'community_center' ],
    icons: {
      default: MarkerNonprofit,
      lgbt: MarkerNonprofitLgbt,
      cert: MarkerNonprofitCert,
      lgbtCert: MarkerNonprofitLgbtCert
    },
  },
  health: {
    types: [ 'health', 'doctor', 'health_services', 'medical_practice', 'doctors_office', 'pharmacy', 'medical_clinic', 'hospital', 'alternative_healthcare', 'dentist', 'physiotherapist', 'psychotherapist', 'care_services', 'psychological_services', 'chiropractor', 'medical_laboratory', 'counselling', 'rehabilitation_center' ],
    icons: {
      default: MarkerHealth,
      lgbt: MarkerHealthLgbt,
      cert: MarkerHealthCert,
      lgbtCert: MarkerHealthLgbtCert
    }
  },
  interest: {
    types: [ 'tourist_attraction', 'route', 'public_artwork', 'historic_site', 'monument', 'landscaping' ],
    icons: {
      default: MarkerInterest,
      lgbt: MarkerInterestLgbt,
      cert: MarkerInterestCert,
      lgbtCert: MarkerInterestLgbtCert
    }
  },
  building: {
    types: [ 'city_hall', 'building', 'place_of_worship', 'locality', 'neighborhood', 'political', 'premise', 'street_address', 'city_hall', 'building', 'place_of_worship', 'locality', 'neighborhood', 'political', 'premise', 'street_address', 'apartment_or_condo', 'government', 'government_offices', 'townhall', 'university_building', 'event_space', 'conference_center' ],
    icons: {
      default: MarkerBuilding,
      lgbt: MarkerBuildingLgbt,
      cert: MarkerBuildingCert,
      lgbtCert: MarkerBuildingLgbtCert
    }
  }
} as const
 
export const MAP_TYPES_CATEGORIES = {
  restauration: {
    icons: {
      default: PointRestauration,
      lgbt: PointRestaurationLgbt
    },
    color: {
      light: '#FF8E48',
      dark: '#FF8E48'
    },
    types: [ 'bar', 'restaurant', 'coffee', 'snack' ]
  },
  shopping: {
    color: {
      light: '#DF7EDC',
      dark: '#F58AE0'
    },
    icons: {
      default: PointShopping,
      lgbt: PointShoppingLgbt
    },
    types: [ 'shop', 'hotel', 'barber', 'wellness' ]
  },
  nightlife: {
    color: {
      light: '#0F2D5B',
      dark: '#B8D0F4'
    },
    icons: {
      default: PointNightlife,
      lgbt: PointNightlifeLgbt
    },
    types: [ 'nightlife' ]
  },
  activity: {
    color: {
      light: '#18556E',
      dark: '#B3DFFF'
    },
    icons: {
      default: PointActivity,
      lgbt: PointActivityLgbt
    },
    types: [ 'activity', 'game', 'outdoor', 'museum' ]
  },
  nonprofit: {
    color: {
      light: '#FE3866',
      dark: '#FFDBE3'
    },
    icons: {
      default: PointNonprofit,
      lgbt: PointNonprofitLgbt
    },
    types: [ 'nonprofit', 'health' ]
  },
  city: {
    color: {
      light: '#3B4048',
      dark: '#A5A8AE'
    },
    icons: {
      default: PointCity,
      lgbt: PointCityLgbt
    },
    types: [ 'interest', 'building']
  }
} as const